import { MARQUEE_ITEMS } from "./data";
import { useSite } from "@/lib/site";

export const Marquee = () => {
  const { content } = useSite();
  const items = content.marquee?.length ? content.marquee.map((m) => m.text) : MARQUEE_ITEMS;

  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-ink/10 bg-sand py-6">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl italic text-ink/70 sm:text-3xl">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-terra" />
          </span>
        ))}
      </div>
    </div>
  );
};
